import React, { ReactElement } from 'react';
import {
  Col, Heading, Link, Row,
} from 'idsk-react-components';
import { useParams } from 'react-router';
import Pripomienka from '../../../model/pripomienka/Pripomienka';
import TypPripomienky from '../../../model/pripomienka/TypPripomienky';
import routes from '../../../routing/routes';
import PripomienkaData from '../../PripomienkaList/component/PripomienkaData/PripomienkaData';
import PripomienkaOdoslanaTag from '../../PripomienkaOdoslanaTag';
import mapDate from '../../../function/mapDate';

interface Props {
  pripomienka: Pripomienka;
}

const PripomienkaForSendRow = ({
  pripomienka,

}: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();

  const getDetailUrl = (): string => (pripomienka.typ === TypPripomienky.HROMADNA
    ? routes.hromadnePripomienky.detail.withParams(type, year, index, pripomienka.uuid)
    : routes.pripomienky.detail.withParams(type, year, index, pripomienka.uuid));

  return (
    <div className="pripomienka-row">
      <Row>
        <Col>
          <Heading className="pripomienka-row-heading" size="s">
            {pripomienka.pripomienkujuciSubjekt}
          </Heading>
        </Col>
      </Row>
      <Row>
        <Col width="one-quarter">
          <PripomienkaData label="Dátum:" value={mapDate(pripomienka.datumPripomienky)} />
          <PripomienkaData label="Pripomienka k:" value={pripomienka.pripomienkaK} />
          <PripomienkaData label="Typ:" value={pripomienka.typ} />
          <PripomienkaOdoslanaTag isOdoslana={pripomienka.odoslana} />
        </Col>
        <Col width="three-quarters">
          <div className="text-overflow">
            {pripomienka.text}
          </div>
        </Col>
      </Row>
      <Row className="pripomienka-detail-button-row">
        <Col>
          <Link
            className="detail-button"
            type="button-primary"
            size="large"
            to={getDetailUrl()}
          >Detail
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default PripomienkaForSendRow;
